import { Component, OnInit } from "@angular/core";
import { EvsAddressService } from "../../../../common/services/EvsAddress.service";
// import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { ModalDistribution2Component } from "../../qrcode/popup/modalDistribution2.component";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";

declare var $: any;

@Component({
  selector: "app-distribution-2",
  templateUrl: "./distribution-2.component.html",
  styleUrls: ["./distribution-2.component.css"],
})
export class Distribution2Component implements OnInit {
  public cities: Array<any> = [];
  public bsModalRef: BsModalRef;
  public currentPage: number = 1;

  constructor(
    public addressService: EvsAddressService,
    public modalService: BsModalService
  ) {}

  ngOnInit() {
    // init select city
    let province = $("#province");
    province.select2({ placeholder: "-- Tỉnh/TP --", allowClear: false });
    this.getCity();

    // init select status of tem
    let temStatus = $("#status");
    temStatus.select2({
      placeholder: "Trạng thái",
      minimumResultsForSearch: -1,
    });
  }

  getCity() {
    this.addressService.getCities().subscribe((res) => {
      let citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }

  showPopupAddDistributor() {
    this.bsModalRef = this.modalService.show(ModalDistribution2Component, {});
    this.bsModalRef.content.closeBtnName = "Bỏ qua";
  }

  selectDistributor() {}
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/distribution-2/distribution-2.component.ts